export const KNOWLEDGE_INDEX_DEFAULT_STATUS = {
  state: "NO_KNOWLEDGE",
  updatedAt: null,
  lastIndexedAt: null,
  chunksIndexed: null,
  lastError: null,
  phase: null,
  progressPercent: null,
  sourcesTotal: null,
  sourcesProcessed: null,
  filesTotal: null,
  tablesTotal: null,
  hasManualContext: null,
  message: null,
};

export const KNOWLEDGE_INDEX_STATE_COPY = {
  NO_KNOWLEDGE: "No knowledge configured yet.",
  INDEXING: "Knowledge index is running.",
  READY: "Knowledge index is ready.",
  FAILED: "Knowledge indexing failed.",
  STALE: "Knowledge changed and needs re-sync.",
};

export const KNOWLEDGE_INDEX_STATE_LABELS = {
  NO_KNOWLEDGE: "No knowledge",
  INDEXING: "Indexing",
  READY: "Ready",
  FAILED: "Failed",
  STALE: "Stale",
};

export function normalizeKnowledgeIndexStatus(status) {
  if (!status || typeof status !== "object") {
    return { ...KNOWLEDGE_INDEX_DEFAULT_STATUS };
  }
  const hasProgressValue =
    status.progressPercent !== null &&
    status.progressPercent !== undefined &&
    String(status.progressPercent).trim() !== "";
  const parsedProgress = hasProgressValue
    ? Number(status.progressPercent)
    : NaN;
  const normalizedProgress = Number.isFinite(parsedProgress)
    ? Math.max(0, Math.min(100, Math.round(parsedProgress)))
    : null;
  return {
    ...KNOWLEDGE_INDEX_DEFAULT_STATUS,
    ...status,
    state: String(
      status.state || KNOWLEDGE_INDEX_DEFAULT_STATUS.state
    ).toUpperCase(),
    progressPercent: normalizedProgress,
    phase: status.phase ? String(status.phase).toUpperCase() : null,
  };
}
